const AUTO_FADE_MS = 2500;

let nonHomeFadeTimerId = null;
let headerLogoHoverBound = false;

function clearNonHomeFadeTimers() {
  if (nonHomeFadeTimerId !== null) {
    window.clearTimeout(nonHomeFadeTimerId);
    nonHomeFadeTimerId = null;
  }
}

function bindHeaderFloatingLogoHover() {
  if (headerLogoHoverBound) return;
  const headerEl = document.querySelector('.js-header');
  if (!headerEl) return;
  headerLogoHoverBound = true;

  const isNonHomeWithLogo = () => {
    const logo = document.querySelector('.js-site-floating-logo');
    return logo && !document.body.classList.contains('page-home');
  };

  const showLogo = () => {
    if (!isNonHomeWithLogo()) return;
    const logo = document.querySelector('.js-site-floating-logo');
    clearNonHomeFadeTimers();
    logo.classList.remove('is-faded');
  };

  const fadeOutImmediately = () => {
    if (!isNonHomeWithLogo()) return;
    const logo = document.querySelector('.js-site-floating-logo');
    clearNonHomeFadeTimers();
    logo.classList.add('is-faded');
  };

  headerEl.addEventListener('pointerenter', showLogo);
  headerEl.addEventListener('pointerleave', fadeOutImmediately);
}

/** Non-home: logo visible on load/navigation, then fades; header hover shows again. */
function scheduleNonHomeFloatingLogoFade() {
  const floatingLogo = document.querySelector('.js-site-floating-logo');
  if (!floatingLogo) return;

  clearNonHomeFadeTimers();

  if (document.body.classList.contains('page-home')) {
    floatingLogo.classList.remove('is-faded');
    return;
  }

  floatingLogo.classList.remove('is-faded');
  bindHeaderFloatingLogoHover();

  nonHomeFadeTimerId = window.setTimeout(() => {
    floatingLogo.classList.add('is-faded');
    nonHomeFadeTimerId = null;
  }, AUTO_FADE_MS);
}

export const intro = (introRan,isHomepage,isEdition) => {

  const introelement = document.getElementById('intro');
  const artwork =  document.getElementById('lines');
  const push  = document.getElementById('push');
  const floatingLogo = document.querySelector('.js-site-floating-logo');
  let nonHomeShrinkTimeout = null;
  let nonHomeShrinkApplied = false;
  const updateFloatingLogoScale = () => {
    if (!floatingLogo) return;
    const minScale = 0.34;
    const maxScale = 1.05;
    const isHomepageNow = document.body.classList.contains('page-home');
    const hasHomepageIntro = isHomepageNow && introelement && introelement.style.display !== 'none';

    // Keep logo compact when there is no active homepage intro.
    // This covers non-home pages and homepage visits where intro is not present.
    if (!hasHomepageIntro) {
      if (!nonHomeShrinkApplied) {
        if (nonHomeShrinkTimeout === null) {
          nonHomeShrinkTimeout = window.setTimeout(() => {
            floatingLogo.style.setProperty('--aaw-logo-scale', minScale.toFixed(3));
            nonHomeShrinkApplied = true;
          }, 700); // brief pause prevents a glitchy immediate shrink on page load
        }
        return;
      }

      floatingLogo.style.setProperty('--aaw-logo-scale', minScale.toFixed(3));
      return;
    }

    // Homepage intro is active: cancel delayed compact-mode timer and use scroll scaling.
    if (nonHomeShrinkTimeout !== null) {
      window.clearTimeout(nonHomeShrinkTimeout);
      nonHomeShrinkTimeout = null;
    }
    nonHomeShrinkApplied = false;

    const scroll = Math.max(0, window.pageYOffset || 0);
    const range = 520;
    const progress = Math.min(scroll / range, 1);
    const scale = maxScale - (maxScale - minScale) * progress;
    floatingLogo.style.setProperty('--aaw-logo-scale', scale.toFixed(3));
  };

  const init = () => {
    
    if(introRan) {
      if(introelement && (isHomepage == true || isEdition == true)) {
        introelement.style.display = "block";
        push.style.display = "block";
      } else {
        if (introelement) introelement.style.display = "none";
        if (push) push.style.display = "none";
      }
    }

    if (introRan == false) {
      bind();
    }

    // Ensure logo scale is recalculated on every init call
    // (including page transitions where no scroll happens).
    updateFloatingLogoScale();
    scheduleNonHomeFloatingLogoFade();

  };

  const bind = () => {


    // const introelement  = document.querySelector(intro);
    let introheight = push.offsetHeight;

    function setIntroHeight() {
      introheight = push.offsetHeight;
      push.style.height = introheight - window.pageYOffset;
      if (artwork) {
        artwork.style.height = introheight - window.pageYOffset;
      }
    }

    function showIntroLines() {
      if (artwork) {
        artwork.classList.add('is-initialised');
      }
    }

 
    // function destroyIntro() {
    //   if(destroyed == false) {
    //
    //     // artwork.style.height = 0;
    //     push.style.height = 0;
    //     window.scrollTo(0, 0);
    //     destroyed = true;
    //   }
    // }

    // function hideIntro() {
    //   introelement.remove();
    // }

    ;(function() {
        var throttle = function(type, name, obj) {
            var obj = obj || window;
            var running = false;
            var func = function() {
                if (running) { return; }
                running = true;
                requestAnimationFrame(function() {
                    obj.dispatchEvent(new CustomEvent(name));
                    running = false;
                });
            };
            obj.addEventListener(type, func);
        };
        throttle ("scroll", "optimizedScroll");
    })();

    window.addEventListener('resize', function() {
      setIntroHeight();
      updateFloatingLogoScale();
    });
    
    // to use the script *without* anti-jank, set the event to "scroll" and remove the anonymous function.
    window.addEventListener("optimizedScroll", function() {
     if( window.pageYOffset < introheight ) {
      setIntroHeight();
     }

     if( introheight - window.pageYOffset < 0 ) {
       // destroyIntro();
       introelement.classList.add('is-hidden');
     } else {
       introelement.classList.remove('is-hidden');
     }

     updateFloatingLogoScale();

    });

    setIntroHeight();
    showIntroLines();
    updateFloatingLogoScale();

  };

  if (typeof(introelement) != 'undefined' && introelement != null) {
    init();
  } else {
    updateFloatingLogoScale();
    scheduleNonHomeFloatingLogoFade();
  }

};
